import  React  from "react";
import './App.css';
import DropBox from "./DropBox"
import NavBar from "./NavBar"
// import Image from "./Image"


function App() {
  return (
    <div className="app" >
     <NavBar />
     <DropBox />
    </div>
  );
}

export default App;
